"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var router_1 = require("@angular/router");
var shared_1 = require("@logbook/shared");
var ng_intercom_1 = require("ng-intercom");
var mixpanel_service_1 = require("@logbook/core/tracking/mixpanel.service");
var mixpanel_event_enum_1 = require("@logbook/core/tracking/mixpanel-event.enum");
var principal_service_1 = require("@logbook/core/auth/services/principal.service");
var account_service_1 = require("@logbook/core/auth/services/account.service");
var operators_1 = require("rxjs/operators");
var SignUpConfirmComponent = /** @class */ (function () {
    function SignUpConfirmComponent(principal, account, router, notificationsService, mixpanelService, intercomService) {
        this.principal = principal;
        this.account = account;
        this.router = router;
        this.notificationsService = notificationsService;
        this.mixpanelService = mixpanelService;
        this.intercomService = intercomService;
    }
    SignUpConfirmComponent.prototype.ngOnInit = function () {
        var _this = this;
        var minLength = forms_1.Validators.minLength, maxLength = forms_1.Validators.maxLength;
        this.userForm = new forms_1.FormGroup({
            firstName: new forms_1.FormControl(null, [
                minLength(1),
                maxLength(25)
            ]),
            lastName: new forms_1.FormControl(null, [
                minLength(1),
                maxLength(25)
            ]),
            pendingCompany: new forms_1.FormControl(null, [
                minLength(1),
                maxLength(25)
            ]),
            phone: new forms_1.FormControl(null, [
                minLength(1),
                maxLength(25)
            ]),
            positionInCompany: new forms_1.FormControl(null, [
                minLength(1),
                maxLength(40)
            ])
        });
        this.success = false;
        this.loadingForm = false;
        this.principal.getAuthenticationState().pipe(operators_1.startWith(this.principal.identityDirect()))
            .subscribe(function (user) {
            _this.currentUser = user;
        });
    };
    Object.defineProperty(SignUpConfirmComponent.prototype, "firstName", {
        get: function () {
            return this.userForm.get('firstName');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SignUpConfirmComponent.prototype, "lastName", {
        get: function () {
            return this.userForm.get('lastName');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SignUpConfirmComponent.prototype, "pendingCompany", {
        get: function () {
            return this.userForm.get('pendingCompany');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SignUpConfirmComponent.prototype, "positionInCompany", {
        get: function () {
            return this.userForm.get('positionInCompany');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SignUpConfirmComponent.prototype, "phone", {
        get: function () {
            return this.userForm.get('phone');
        },
        enumerable: true,
        configurable: true
    });
    SignUpConfirmComponent.prototype.save = function () {
        var _this = this;
        if (this.userForm.invalid) {
            this.error = 'ERROR';
        }
        else {
            var body_1 = this.userForm.value;
            body_1.userId = this.currentUser.userId;
            body_1.email = this.currentUser.email;
            body_1.phones = [this.phone.value];
            // in case of invited people, company is already set and pendingCompany must stay undefined
            var pendingCompanyNom_1 = '';
            // in case of company not set yet, pendingCompany must be settable
            if (body_1.pendingCompany) {
                pendingCompanyNom_1 = body_1.pendingCompany.nom;
                body_1.pendingCompany = body_1.pendingCompany.id;
            }
            this.account.save(body_1).pipe(operators_1.first()).subscribe(function () {
                _this.error = null;
                _this.notificationsService.success("Account update", 'Your account has been successfully updated');
                _this.mixpanelService.track(mixpanel_event_enum_1.MixpanelEvent.ACCOUNT_DETAIL_CHANGE);
                _this.intercomService.boot({
                    user_id: body_1.userId,
                    companies: [{
                            name: pendingCompanyNom_1,
                            company_id: pendingCompanyNom_1
                        }]
                });
                _this.principal.identity(true).then(function () {
                    _this.router.navigate(["/"]);
                });
            }, function () {
                _this.notificationsService.error("Account update", 'Your account cannot be update');
                _this.success = null;
                _this.error = 'ERROR';
            });
        }
    };
    SignUpConfirmComponent.prototype.goHome = function () {
        this.router.navigateByUrl("/");
    };
    return SignUpConfirmComponent;
}());
exports.SignUpConfirmComponent = SignUpConfirmComponent;
